/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleWithIdDto } from '../../models/article-with-id-dto';

export interface ShopUpdateArticle$Params {
  'x-trace-id'?: string;
  id: string;
      body: ArticleWithIdDto
}

export function shopUpdateArticle(http: HttpClient, rootUrl: string, params: ShopUpdateArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleWithIdDto>> {
  const rb = new RequestBuilder(rootUrl, shopUpdateArticle.PATH, 'put');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticleWithIdDto>;
    })
  );
}

shopUpdateArticle.PATH = '/api/shop/article/{id}';
